/**
 * @generated SignedSource<<deb6062c80f0fd24a72c5e64f23d4344>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharePostButtonFragment$data = {
  readonly id: string;
  readonly releasedAt: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  readonly " $fragmentType": "SharePostButtonFragment";
};
export type SharePostButtonFragment$key = {
  readonly " $data"?: SharePostButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharePostButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharePostButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "releasedAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    }
  ],
  "type": "Post",
  "abstractKey": null
};

(node as any).hash = "14b8c4606b4a8dc2fadbf6f10d4d29ce";

export default node;
